var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 468.293 468.293",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.525 50.447h111.996c7.335 0 14.11 3.918 17.77 10.274l18.433 25.181a20.507 20.507 0 0017.77 10.274h272.798v287.495c0 15.099-12.241 27.34-27.34 27.34H27.34C12.241 411.011 0 398.77 0 383.671V128.068a205.16 205.16 0 019.68-62.276 20.505 20.505 0 0119.845-15.345z",
    fill: "#f6c358"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebf0f3",
    d: "M42.615 91.473h359.961v152.058H42.615z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M447.788 64.117H334.927a20.504 20.504 0 00-18.65 11.983l-19.313 42.267a20.505 20.505 0 01-18.65 11.983H0v260.155c0 15.099 12.241 27.34 27.34 27.34h413.613c15.099 0 27.34-12.241 27.34-27.34V84.622c0-11.324-9.181-20.505-20.505-20.505z",
    fill: "#fcd462"
  })));
}

export default SvgFolder;